var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentxLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 103,
    viewBox: "0 0 751 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.205 0V101.3H134V0H143.205Z",
    fill: "url(#paint0_linear_1897_3996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.126 102.932C177.944 102.932 172.507 101.3 167.815 98.037C163.167 94.7283 159.535 90.1052 156.918 84.1677C154.346 78.2301 153.06 71.3408 153.06 63.4997C153.06 55.7039 154.368 48.8598 156.985 42.9677C159.602 37.0755 163.235 32.4977 167.882 29.2343C172.575 25.9256 178.012 24.2713 184.194 24.2713C188.841 24.2713 192.677 25.1098 195.7 26.7868C198.768 28.4185 201.227 30.4354 203.077 32.8376C204.973 35.2398 206.417 37.574 207.409 39.8403H208.154V0H216.885V101.3H208.424V87.1591H207.409C206.417 89.4706 204.973 91.8502 203.077 94.2977C201.182 96.7452 198.701 98.8075 195.632 100.484C192.564 102.116 188.729 102.932 184.126 102.932ZM185.141 94.9096C190.06 94.9096 194.234 93.5498 197.663 90.8304C201.092 88.1109 203.709 84.3943 205.514 79.6805C207.364 74.9215 208.289 69.5052 208.289 63.4317C208.289 57.3129 207.387 51.9193 205.582 47.2508C203.777 42.5824 201.137 38.9338 197.663 36.305C194.234 33.6308 190.06 32.2937 185.141 32.2937C180.133 32.2937 175.891 33.6761 172.417 36.4409C168.943 39.2057 166.303 42.945 164.498 47.6587C162.738 52.3272 161.858 57.5848 161.858 63.4317C161.858 69.2785 162.761 74.5815 164.566 79.3406C166.371 84.0997 168.988 87.8843 172.417 90.6944C175.891 93.5045 180.133 94.9096 185.141 94.9096Z",
    fill: "url(#paint1_linear_1897_3996)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.431 102.932C252.391 102.932 246.277 101.278 241.088 97.969C235.899 94.615 231.906 89.9919 229.108 84.0997C226.311 78.2075 224.912 71.4315 224.912 63.7716C224.912 56.1118 226.288 49.3131 229.041 43.3756C231.838 37.4381 235.719 32.7696 240.682 29.3703C245.646 25.971 251.399 24.2713 257.941 24.2713C262.002 24.2713 265.951 25.0418 269.786 26.5828C273.621 28.0786 277.073 30.3674 280.142 33.4495C283.21 36.5316 285.624 40.4521 287.384 45.2112C289.143 49.925 290.023 55.5452 290.023 62.0719V66.0152H230.936V58.2647H285.285L281.292 61.2561C281.292 55.7265 280.345 50.7861 278.449 46.435C276.599 42.0838 273.937 38.6392 270.463 36.101C266.988 33.5628 262.815 32.2937 257.941 32.2937C253.113 32.2937 248.872 33.5855 245.217 36.169C241.562 38.7072 238.719 42.1065 236.689 46.367C234.704 50.5822 233.711 55.2053 233.711 60.2363V64.7914C233.711 70.8649 234.749 76.1679 236.824 80.7003C238.945 85.1875 241.923 88.6775 245.758 91.1703C249.639 93.6632 254.196 94.9096 259.431 94.9096C262.995 94.9096 266.131 94.343 268.838 93.2099C271.546 92.0768 273.824 90.5584 275.674 88.6548C277.524 86.7058 278.923 84.5982 279.871 82.332L288.196 85.1195C287.023 88.2922 285.128 91.2383 282.51 93.9578C279.939 96.6319 276.69 98.8075 272.764 100.484C268.884 102.116 264.439 102.932 259.431 102.932Z",
    fill: "url(#paint2_linear_1897_3996)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.443 53.8455V101.3H297.712V25.2911H306.173V37.3248H307.052C308.812 33.3815 311.565 30.2315 315.31 27.8746C319.055 25.5177 323.702 24.3393 329.253 24.3393C334.351 24.3393 338.818 25.4044 342.654 27.5347C346.534 29.6649 349.557 32.7923 351.723 36.9168C353.889 41.0414 354.972 46.1177 354.972 52.1459V101.3H346.241V52.6898C346.241 46.4803 344.504 41.5399 341.029 37.8686C337.555 34.1974 332.907 32.3617 327.087 32.3617C323.116 32.3617 319.574 33.2455 316.46 35.0132C313.347 36.7355 310.888 39.2057 309.083 42.4238C307.323 45.5965 306.443 49.4037 306.443 53.8455Z",
    fill: "url(#paint3_linear_1897_3996)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M396.57 25.2911V32.9736H360.495V25.2911H396.57ZM371.798 7.2066H380.529V81.4482C380.529 85.5727 381.545 88.6775 383.575 90.7624C385.605 92.802 388.426 93.8218 392.035 93.8218C392.848 93.8218 393.66 93.7765 394.472 93.6858C395.329 93.5498 396.232 93.3685 397.179 93.1419L399.074 101.096C398.037 101.504 396.841 101.822 395.487 102.048C394.134 102.275 392.735 102.388 391.291 102.388C385.696 102.388 381.048 100.666 377.348 97.2211C373.648 93.7311 371.798 89.176 371.798 83.5558V7.2066Z",
    fill: "url(#paint4_linear_1897_3996)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.757 25.2911L430.182 57.7888L449.674 25.2911H459.827L435.596 63.3637L459.827 101.3H449.674L430.182 69.9584L410.757 101.3H400.536L424.564 63.3637L400.536 25.2911H410.757Z",
    fill: "url(#paint5_linear_1897_3996)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496.592 101.3V0H505.797V93.0059H553.92V101.3H496.592Z",
    fill: "url(#paint6_linear_1897_3996)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M582.658 103C578.101 103 573.927 102.116 570.137 100.349C566.347 98.5355 563.324 95.9294 561.067 92.53C558.856 89.0854 557.751 84.9155 557.751 80.0205C557.751 76.2585 558.45 73.1085 559.849 70.5703C561.248 68.0321 563.256 65.9472 565.873 64.3155C568.49 62.6385 571.558 61.3241 575.078 60.3723C578.642 59.3751 582.568 58.6273 586.855 58.1287C591.096 57.5848 594.683 57.1316 597.616 56.769C600.549 56.3611 602.783 55.7265 604.317 54.8653C605.851 54.0042 606.618 52.6218 606.618 50.7182V48.9505C606.618 43.7382 605.084 39.659 602.016 36.7129C598.947 33.7215 594.548 32.2257 588.818 32.2257C583.358 32.2257 578.913 33.4268 575.484 35.829C572.055 38.2312 569.663 41.064 568.31 44.3274L559.917 41.268C561.631 37.1435 564 33.8348 567.024 31.3419C570.047 28.8491 573.431 27.0587 577.176 25.971C580.921 24.8378 584.711 24.2713 588.547 24.2713C591.435 24.2713 594.435 24.6565 597.549 25.4271C600.662 26.1976 603.572 27.512 606.28 29.3703C608.987 31.2286 611.176 33.8348 612.845 37.1888C614.56 40.4975 615.417 44.69 615.417 49.7663V101.3H606.618V89.2667H606.077C605.084 91.4876 603.55 93.6631 601.474 95.7934C599.399 97.8783 596.804 99.6007 593.691 100.96C590.577 102.32 586.9 103 582.658 103ZM583.877 94.9776C588.524 94.9776 592.54 93.9578 595.924 91.9182C599.354 89.8332 601.993 87.0458 603.843 83.5558C605.693 80.0658 606.618 76.2585 606.618 72.134V61.1881C605.941 61.8227 604.836 62.3892 603.302 62.8878C601.813 63.3864 600.076 63.8169 598.09 64.1795C596.15 64.5421 594.165 64.8594 592.134 65.1314C590.149 65.4033 588.389 65.6299 586.855 65.8112C582.613 66.3551 578.958 67.1936 575.89 68.3267C572.867 69.4598 570.543 71.0009 568.919 72.9498C567.339 74.8988 566.55 77.4143 566.55 80.4964C566.55 85.0742 568.174 88.6321 571.423 91.1703C574.717 93.7085 578.868 94.9776 583.877 94.9776Z",
    fill: "url(#paint7_linear_1897_3996)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M660.061 102.932C655.504 102.932 651.668 102.116 648.555 100.484C645.486 98.8075 643.005 96.7452 641.11 94.2977C639.26 91.8502 637.816 89.4706 636.778 87.1591H635.763V101.3H627.302V0H636.033V39.8403H636.778C637.816 37.574 639.26 35.2398 641.11 32.8376C642.96 30.4354 645.419 28.4185 648.487 26.7868C651.555 25.1098 655.391 24.2713 659.993 24.2713C666.22 24.2713 671.657 25.9256 676.305 29.2343C680.998 32.4977 684.652 37.0755 687.27 42.9677C689.887 48.8598 691.195 55.7039 691.195 63.4997C691.195 71.3408 689.887 78.2301 687.27 84.1677C684.698 90.1052 681.065 94.7283 676.373 98.037C671.725 101.3 666.288 102.932 660.061 102.932ZM659.113 94.9096C664.077 94.9096 668.296 93.5045 671.77 90.6944C675.245 87.8843 677.884 84.0997 679.689 79.3406C681.494 74.5815 682.396 69.2785 682.396 63.4317C682.396 57.5848 681.494 52.3272 679.689 47.6587C677.884 42.945 675.267 39.2057 671.838 36.4409C668.409 33.6761 664.167 32.2937 659.113 32.2937C654.15 32.2937 649.953 33.6308 646.524 36.305C643.095 38.9338 640.478 42.5824 638.673 47.2508C636.868 51.9193 635.966 57.3129 635.966 63.4317C635.966 69.5052 636.868 74.9215 638.673 79.6805C640.478 84.3943 643.095 88.1109 646.524 90.8304C649.999 93.5498 654.195 94.9096 659.113 94.9096Z",
    fill: "url(#paint8_linear_1897_3996)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M749.917 42.0838L741.93 44.2594C740.757 40.8601 738.794 37.982 736.042 35.6251C733.335 33.2229 729.432 32.0218 724.333 32.0218C719.234 32.0218 715.038 33.2682 711.744 35.7611C708.45 38.2086 706.803 41.3586 706.803 45.2112C706.803 48.4293 707.908 51.0807 710.119 53.1657C712.375 55.2053 715.85 56.8143 720.543 57.9927L731.981 60.7802C738.298 62.3666 743.036 64.8367 746.195 68.1908C749.398 71.4995 751 75.692 751 80.7683C751 85.0288 749.804 88.8361 747.413 92.1901C745.066 95.5441 741.795 98.1729 737.599 100.077C733.402 101.98 728.529 102.932 722.979 102.932C715.579 102.932 709.488 101.255 704.705 97.901C699.922 94.5017 696.853 89.6519 695.5 83.3518L703.893 81.3122C704.93 85.7993 707.051 89.1987 710.255 91.5102C713.458 93.8218 717.655 94.9776 722.844 94.9776C728.619 94.9776 733.267 93.6631 736.787 91.0343C740.306 88.4055 742.066 85.1421 742.066 81.2442C742.066 74.9894 737.937 70.8422 729.68 68.8026L717.361 65.8112C710.774 64.2249 705.9 61.732 702.742 58.3327C699.583 54.9333 698.004 50.6955 698.004 45.6191C698.004 41.4493 699.132 37.7553 701.388 34.5373C703.689 31.3193 706.825 28.8037 710.796 26.9908C714.767 25.1778 719.279 24.2713 724.333 24.2713C731.282 24.2713 736.832 25.8803 740.983 29.0984C745.134 32.2711 748.112 36.5996 749.917 42.0838Z",
    fill: "url(#paint9_linear_1897_3996)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 62.7683H7.77757C3.48214 62.7683 0 66.2505 0 70.5459V93.2224C0 97.5178 3.48214 101 7.77757 101H30.4541C34.7495 101 38.2316 97.5178 38.2316 93.2224V70.5459C38.2316 66.2505 34.7495 62.7683 30.4541 62.7683Z",
    fill: "#15052A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2224 0H70.5459C66.2505 0 62.7683 3.48214 62.7683 7.77757V30.4541C62.7683 34.7495 66.2505 38.2316 70.5459 38.2316H93.2224C97.5178 38.2316 101 34.7495 101 30.4541V7.77757C101 3.48214 97.5178 0 93.2224 0Z",
    fill: "#15052A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3181 68.7542L32.2458 2.68192C30.9962 1.05565 29.0332 0 26.8192 0H6.84746C3.06424 0 0 3.06424 0 6.84746V26.8192C0 28.8563 0.895876 30.6766 2.30531 31.932L2.28249 31.9548L69.6158 99.2881L69.6386 99.2653C70.8484 100.338 72.4347 101 74.1808 101H94.1525C97.9358 101 101 97.9358 101 94.1525V74.1808C101 71.9668 99.9444 70.0038 98.3181 68.7542Z",
    fill: "#15052A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1897_3996",
    x1: 0,
    y1: 51.5,
    x2: 751,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15052A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#472E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#6382C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentxLogoFull);
export default __webpack_public_path__ + "static/media/IdentxLogoFull.1b3906ccb20df8926e1320f9ebf56667.svg";
export { ForwardRef as ReactComponent };